import type { TranslateDictionary } from './en.js';

export const Fr: TranslateDictionary = {
  'Drop a video file here to upload': 'Déposez un fichier vidéo ici pour le télécharger',
  or: 'ou',
  'Upload complete!': 'Téléchargement terminé!',
  Retry: 'Réessayer',
  'Pausing...': 'En pause...',
  Resume: 'Reprendre',
  Pause: 'Pause',
  'Upload a video': 'Télécharger une vidéo',
  'No url or endpoint specified - cannot handle upload':
    'Aucune URL ou point de terminaison spécifié - impossible de gérer le téléchargement',
};
